// assets/header-desktop-drawer.js
(() => {
  const DESKTOP_MIN = 750;
  const isDesktop = () => window.matchMedia(`(min-width:${DESKTOP_MIN}px)`).matches;

  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const log = (...a) => console.log("[DesktopDrawer]", ...a);

  // ---------------- RIGHT DESKTOP OVERLAY (hide it) ----------------
  function getRightDesktopOverlay() {
    return qs("[data-desktop-drawer-overlay]");
  }

  function hideRightDesktopOverlay() {
    const overlay = getRightDesktopOverlay();
    if (!overlay) return false;

    overlay.style.setProperty("display", "none", "important");
    overlay.style.setProperty("visibility", "hidden", "important");
    overlay.style.setProperty("opacity", "0", "important");
    overlay.style.setProperty("pointer-events", "none", "important");
    overlay.setAttribute("aria-hidden", "true");
    return true;
  }

  function keepOverlayHiddenLightweight() {
    if (!isDesktop()) return;
    hideRightDesktopOverlay();
    [200, 600, 1200, 2500].forEach((t) => setTimeout(hideRightDesktopOverlay, t));
  }

  // ---------------- MOBILE DRAWER WRAPPER (use on desktop temporarily) ----------------
  function getMobileDrawerWrapper() {
    return (
      qs('[ref="headerDrawerContainer"]') ||
      qs(".header__drawer.header__drawer--mobile") ||
      qsa(".header__drawer").find((el) => el.classList.contains("desktop:hidden")) ||
      null
    );
  }

  function setWrapperEnabled(enabled) {
    const wrap = getMobileDrawerWrapper();
    if (!wrap) return null;

    if (enabled) {
      wrap.style.setProperty("display", "block", "important");
      wrap.style.setProperty("visibility", "visible", "important");
      wrap.style.setProperty("opacity", "1", "important");
      wrap.style.setProperty("pointer-events", "auto", "important");
    } else {
      // po zavření zase schovat, aby nezůstal hamburger v headeru
      wrap.style.setProperty("display", "none", "important");
      wrap.style.setProperty("visibility", "hidden", "important");
      wrap.style.setProperty("opacity", "0", "important");
      wrap.style.setProperty("pointer-events", "none", "important");
    }
    return wrap;
  }

  function getDrawerContainerDetails(root = document) {
    return (
      qs("details#Details-menu-drawer-container", root) ||
      qs('details[id*="menu-drawer-container" i]', root) ||
      qs('details[id*="menu-drawer" i]', root) ||
      null
    );
  }

  // ✅ SCHOVAT JEN opener (hamburger) – NIKDY ne summary uvnitř menu
  function hideOnlyDrawerOpener(wrap, containerDetails) {
    if (!wrap) return;

    // 1) explicitní hamburger ikona
    qsa(".header__icon--menu, [class*='icon--menu']", wrap).forEach((el) => {
      el.style.setProperty("display", "none", "important");
      el.style.setProperty("visibility", "hidden", "important");
      el.style.setProperty("pointer-events", "none", "important");
    });

    // 2) summary/button, který ovládá *container* (ne vnitřní kategorie)
    //    → hledáme pouze ten, co cílí na menu-drawer-container
    const opener =
      qs('summary[aria-controls*="menu-drawer-container" i]', wrap) ||
      qs('button[aria-controls*="menu-drawer-container" i]', wrap) ||
      qs('summary[id*="HeaderDrawer-menu-drawer-container" i]', wrap) ||
      null;

    if (opener) {
      opener.style.setProperty("display", "none", "important");
      opener.style.setProperty("visibility", "hidden", "important");
      opener.style.setProperty("pointer-events", "none", "important");
    }

    // 3) když opener není v wrapu, ale je uvnitř containerDetails jako první summary
    if (containerDetails) {
      const sum = qs(":scope > summary", containerDetails);
      if (sum) {
        sum.style.setProperty("display", "none", "important");
        sum.style.setProperty("visibility", "hidden", "important");
        sum.style.setProperty("pointer-events", "none", "important");
      }
    }
  }

  function openDrawerContainer(container) {
    if (!container) return false;
    if (!container.open) {
      const summary = qs("summary", container);
      if (summary) summary.click();
      else container.open = true;
    }
    return true;
  }

  // Najdi <details> podle textu položky v summary (Tenisky / Oblečení)
  function findDetailsByMenuText(container, labelText) {
    if (!container || !labelText) return null;
    const norm = (s) => (s || "").trim().toLowerCase();
    const wanted = norm(labelText);

    const summaries = qsa("summary", container);
    for (const summary of summaries) {
      // text prvku uvnitř menu
      const textEl =
        qs(".menu-drawer__menu-item-text", summary) ||
        qs(".menu-drawer__menu-item-text span", summary);
      const t = norm(textEl ? textEl.textContent : summary.textContent);

      if (t === wanted) {
        const details = summary.closest("details");
        if (details) return details;
      }
    }
    return null;
  }

  function openDetails(detailsEl) {
    if (!detailsEl) return false;
    if (!detailsEl.open) {
      const summary = qs("summary", detailsEl);
      if (summary) summary.click();
      else detailsEl.open = true;
    }
    return true;
  }

  function attachAutoCleanup(container) {
    if (!container || container.__desktopDrawerCleanupBound) return;
    container.__desktopDrawerCleanupBound = true;

    container.addEventListener(
      "toggle",
      () => {
        if (!isDesktop()) return;
        if (!container.open) {
          setWrapperEnabled(false);
          log("✅ Drawer closed -> wrapper hidden (no leftover hamburger)");
        }
      },
      false
    );
  }

  // ---------------- CLICK HANDLER ----------------
  function onClick(e) {
    if (!isDesktop()) return;

    const a = e.target.closest("[data-desktop-drawer-trigger]");
    if (!a) return;

    const hasChildren = a.getAttribute("data-has-children") === "true";
    if (!hasChildren) return;

    e.preventDefault();
    e.stopPropagation();

    const labelText = (a.textContent || "").trim(); // "Tenisky", "Oblečení"
    log("Click:", { labelText });

    hideRightDesktopOverlay();

    const wrap = setWrapperEnabled(true);
    if (!wrap) {
      log("❌ Mobile drawer wrapper not found");
      return;
    }

    const container = getDrawerContainerDetails(wrap) || getDrawerContainerDetails(document);
    if (!container) {
      log("❌ Drawer container details not found");
      return;
    }

    // ✅ schovej jen opener – tím pádem menu texty zůstanou viditelné
    hideOnlyDrawerOpener(wrap, container);

    attachAutoCleanup(container);
    openDrawerContainer(container);

    // otevři rovnou sekci podle textu (Tenisky/Oblečení)
    [80, 160, 260, 420].forEach((t) => {
      setTimeout(() => {
        const targetDetails = findDetailsByMenuText(container, labelText);
        if (targetDetails) {
          openDetails(targetDetails);
          targetDetails.scrollIntoView?.({ block: "nearest" });
          log("✅ Opened section by text:", labelText);
        }
      }, t);
    });
  }

  function init() {
    if (isDesktop()) {
      setWrapperEnabled(false);
      keepOverlayHiddenLightweight();
    }

    document.addEventListener("click", onClick, true);
    log("✅ header-desktop-drawer.js loaded");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
